import './index.scss';
import { useDeviceInitializer } from '@packages/common/hooks/useDeviceInitializer';

import { Helmet } from '@modern-js/runtime/head';
import { GlobalSuspenseLoader } from '@packages/common/components/GlobalSuspenseLoader';
import { helmetConfig } from 'config/helmet/helmet.config';
import { Suspense } from 'react';
import { lazily } from 'react-lazily';

const { GlobalLayout } = lazily(
	() => import('components/GlobalLayout/GlobalLayout'),
);
const Layout = () => {
	const deviceInitialized = useDeviceInitializer();
	return deviceInitialized ? (
		<Suspense fallback={<GlobalSuspenseLoader />}>
			<Helmet {...helmetConfig.app} />
			<GlobalLayout />
		</Suspense>
	) : null;
};

export default Layout;
